import { Typography, useMediaQuery, useTheme } from "@mui/material";

export default function LogoText(props: { className?: string }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <div className={`center-wrapper ${props.className || ""}`}>
      <svg
        preserveAspectRatio="xMidYMid meet"
        data-bbox="144.92 99.93 50.159 50.139"
        colorInterpolationFilters="sRGB"
        viewBox="144.419 99.429 51.163 51.143"
        height={!isMobile ? "60" : "0"}
        width={!isMobile ? "60" : "0"}
        xmlns="http://www.w3.org/2000/svg"
        data-type="ugc"
        role="presentation"
        aria-hidden="true"
        aria-label=""
      >
        <g transform="translate(144.92 99.93)">
          <path
            className="image-rect"
            fill="none"
            d="M50.159 0v50.139H0V0h50.159z"
          ></path>
          <svg
            className="image-svg-svg primary"
            height="50.139"
            width="50.159"
            filter="url(#b43a4b8f-140a-41fc-9340-b1605a96d3b7_comp-lt62fn1e)"
            overflow="visible"
          >
            <svg
              viewBox="9.967 9.991 80.042 80.01"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M67.99 14.27c19.729 9.94 27.67 33.98 17.74 53.72l-7.521-7.79c5.64-15.58-2.43-32.78-18.01-38.41-.312-.12-.92-.32-1.24-.42l-5.33-2.05 2.91 3.35 21.67 37.53 6.04 10.46c-.75 1.31-2.4 3.64-3.39 4.779-14.052 17.051-39.262 19.48-56.302 5.42l3.102-10.829c11.06 12.329 30.029 13.37 42.37 2.31.63-.55 1.76-1.68 2.31-2.31L66.55 60H36.36l2.87-10h20.229l2.61.75-1.95-1.89-9.46-16.38-.66-2.64-.66 2.64L39.23 50 27.66 70.03l-5.19 8.989C9.821 67.77 6.18 46.88 14.27 32.01c9.94-19.73 33.98-27.67 53.72-17.74zm-24.53 8.4 2.91-3.35-5.33 2.05C26.26 25.83 17.2 41.53 20.72 56.55l.892 5.65L23.06 58l20.4-35.33z"></path>
            </svg>
          </svg>
          <defs>
            <filter id="b43a4b8f-140a-41fc-9340-b1605a96d3b7_comp-lt62fn1e">
              <feColorMatrix
                className="icon-feColorMatrix"
                values="0 0 0 0 0.71875 0 0 0 0 0.375 0 0 0 0 0.8984375 0 0 0 1 0"
              ></feColorMatrix>
            </filter>
          </defs>
        </g>
      </svg>
      {!isMobile && (
        <Typography
          sx={{ ml: 2 }}
          variant={"h4"}
          color="primary"
          fontWeight="bolder"
        >
          ALFA CG
        </Typography>
      )}
    </div>
  );
}
